import { DocumentIcon } from "@logora/parliament.icons.regular_icons";
import {
	formatActeur,
	formatCapitalize,
	formatChambre,
	formatDate,
	formatLabel,
	formatNumero,
	formatCell,
} from "../formatters";

const columns = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Date",
		accessorKey: "dateCreation",
		cell: (info) => formatDate(formatCell(info)),
		defaultSorting: "desc",
		meta: {
			filter: {
				label: "Date de création",
				variant: "date-range",
				labels: ["Après le", "Avant le"],
			},
		},
	},
	{
		header: "Type",
		accessorKey: "typeLibelle",
		cell: (info) => formatLabel(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Type",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "Proposition de loi", label: "Proposition de loi" },
					{ value: "Projet de loi", label: "Projet de loi" },
					{
						value: "Proposition de résolution",
						label: "Proposition de résolution",
					},
					{ value: "Motion", label: "Motion" },
					{ value: "Rapport", label: "Rapport" },
					{ value: "Rapport d'information", label: "Rapport d'information" },
					{ value: "Avis", label: "Avis" },
					{ value: "Accord international", label: "Accord international" },
				],
			},
		},
	},
	{
		header: "Auteur",
		accessorKey: "auteurPrincipal",
		cell: (info) => formatActeur(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Numéro",
		accessorKey: "numNotice",
		cell: (info) => formatNumero(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Numéro",
			},
		},
	},
	{
		header: "Titre",
		accessorKey: "titrePrincipalCourt",
		cell: (info) => formatCapitalize(formatCell(info)),
		enableSorting: false,
	},
];

export const documentDataset = {
	key: "documents",
	name: "Documents",
	columns: columns,
	filterMapping: {
		acteurRefUid: "auteurPrincipalUid",
		organeRefUid: "auteurPrincipal_groupeParlementaireUid",
	},
	searchTable: "alineas",
	searchPlaceholder: "Rechercher un document...",
	include: ["auteurPrincipal.groupeParlementaire", "alineas"],
	icon: <DocumentIcon width={20} height={20} />,
};
